export interface ComboType {
  id: number
  name: string
  crop_id: number | null
  stage_id: number | null
  image: string | null
  description: string
  intro: string
  type: 'COMBO' | 'KIT'
  slug_info: {
    slug: string
    redirect_url: string | null
    metadata: Record<string, unknown> | null
  }
  variants: ComboVariant[]
}

export interface ComboVariant {
  id: number
  applicable_acres: number
  price: number
  discount_amount: number
  discount_type: ComboDiscountType
  discount_value: number
  items: ComboVariantItem[]
  is_sellable: boolean
}

export interface ComboVariant2 {
  id: number
  applicable_acres: number
  price: number
  discount_amount: number
  discount_type: ComboDiscountType
  discount_value: number
  items: ComboVariantItem[]
  is_sellable: boolean
  name: string
  parent_id: number
  parent_type: 'COMBO' | 'KIT'
  image: string
  slug_info: {
    slug: string
    redirect_url: string | null
    metadata: Record<string, unknown> | null
  }
}

export enum ComboDiscountType {
  FLAT = 'FLAT',
  PERCENTAGE = 'PERCENTAGE',
}

export interface ComboVariantItem {
  id: number
  product_variant_id: number
  product_name: string
  unit_price: number
  units_per_kit: number
  marks_for_buy_x_get_y: boolean
  attribute_value: ComboAttribute[]
  slug_info: {
    slug: string
    redirect_url: string | null
    metadata: Record<string, unknown>
  }
  brand: string
  product_image: string
}

export interface ComboAttribute {
  name: string
  attribute: { name: string }
}
